module.exports = __webpack_public_path__ + "img/jyServiceItem6.64878a38.png";